import {
  put,
  takeLatest,
} from 'redux-saga/effects';

import { receiveSearchValue, rejectSearchValue, requestSearchValue } from '../actions/main-page';

interface ISetSearchValueAction {
  type: string;
  payload: {
    searchValue: boolean;
  }
}

const setSearchValue = function* setSearchValue(action: ISetSearchValueAction) {
  try {
    yield put(receiveSearchValue({ searchValue: action.payload.searchValue }));
  } catch (error) {
    yield put(rejectSearchValue({ error }));
  }
};

export default function* setSearchValueWatcher() {
  yield takeLatest(requestSearchValue, setSearchValue);
}
